export default "__VITE_ASSET__CczK6Jhq__"